<template>
  <div>
    <pre>{{ template }}</pre>
    <!-- <pre>{{ transaction.setup }}</pre> -->
    <!-- <pre>{{ xmlFormat(transaction.request_data) }}</pre> -->
    <!-- <div class="ui form">
      <div class="ui dividing small header">{{ $t("sale") }}</div>
      <div class="three fields">
        <div class="field">
          <label for="">{{ $t("pan") }}</label>
          <input type="text" v-model="transaction.request_data.pan" />
        </div>
        <div class="field">
          <label for="">{{ $t("amount") }}</label>
          <input
            type="text"
            :value="transaction.request_data.amount | formatVisaCurrency"
          />
        </div>
        <div class="field">
          <label for="">{{ $t("audit number") }}</label>
          <input type="text" v-model="transaction.request_data.auditNumber" />
        </div>
      </div>
      <div class="ui dividing small header">{{ $t("merchant") }}</div>
      <div class="four fields">
        <div class="field">
          <label for="">{{ $t("pos entry mode") }}</label>
          <input type="text" v-model="transaction.request_data.posEntryMode" />
        </div>
        <div class="field">
          <label for="">{{ $t("terminal id") }}</label>
          <input type="text" v-model="transaction.request_data.terminalId" />
        </div>
        <div class="field">
          <label for="">{{ $t("merchant") }}</label>
          <input type="text" v-model="transaction.request_data.merchant" />
        </div>
        <div class="field">
          <label for="">{{ $t("message type") }}</label>
          <input type="text" v-model="transaction.request_data.messageType" />
        </div>
      </div>
      <div class="field">
        <label for="">{{ $t("merchant user") }}</label>
        <input type="text" v-model="transaction.request_data.merchantUser" />
      </div>
      <div class="ui dividing small header">
        {{ $t("transaction source") }}
      </div>
      <div class="three fields">
        <div class="field">
          <label for="">{{ $t("payment gateway ip") }}</label>
          <input type="text" v-model="transaction.request_data.paymentgwIP" />
        </div>
        <div class="field">
          <label for="">{{ $t("shopper ip") }}</label>
          <input type="text" v-model="transaction.request_data.shopperIP" />
        </div>
        <div class="field">
          <label for="">{{ $t("merchant server ip") }}</label>
          <input
            type="text"
            v-model="transaction.request_data.merchantServerIP"
          />
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import filters from "@/filters";
import { translate_status, translate_type } from "../local_translator";
import xmlFormat from "xml-formatter";

filters.translate_status = translate_status;
filters.translate_type = translate_type;

export default {
  name: "FelGTTransactionModalRequest",
  filters: filters,
  components: {},
  computed: {
    template() {
      let vm = this;

      if (vm.transaction.request_data) {
        // console.log("parsing", vm.transaction.request_data);
        let format = xmlFormat(vm.transaction.request_data);
        return format;
      } else return "";
    },
  },
  props: { transaction: Object },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  watch: {},
  updated: function () {},
};
</script>
